var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8235 3H11.0975C10.8995 3 10.7083 2.92125 10.5673 2.78025L10.2568 2.46975C10.1165 2.3295 9.92527 2.25 9.72727 2.25H8.84752C8.64952 2.25 8.45827 2.3295 8.31727 2.46975L8.00677 2.78025C7.86652 2.92125 7.67527 3 7.47727 3H3.75052C3.46627 3 3.20677 3.1605 3.08002 3.41475C2.83102 3.9135 3.19327 4.5 3.75052 4.5H14.8235C15.3808 4.5 15.7438 3.9135 15.4948 3.41475C15.368 3.1605 15.1078 3 14.8235 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2875 15.7499H6.28746C5.92071 15.7499 5.60796 15.4844 5.54796 15.1237L4.04796 6.12369C3.97971 5.71494 4.25571 5.32794 4.66446 5.26044C5.07321 5.19069 5.45946 5.46819 5.52696 5.87619L6.92271 14.2499H11.6522L13.048 5.87619C13.1155 5.46819 13.501 5.18994 13.9105 5.26044C14.3192 5.32794 14.5952 5.71494 14.527 6.12369L13.027 15.1237C12.967 15.4844 12.6542 15.7499 12.2875 15.7499Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trash-bin.b0ba8c7a5b35e9c9b26383d81d3b7694.svg";
export { ForwardRef as ReactComponent };